// extracted by mini-css-extract-plugin
export default {"list_menu":"index_list_menu_0hIPd","morehNew":"index_morehNew_dOAdU","more":"index_more_-MXpd"};